import AuthService from "../../utilities/services/auth.service";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { UserBalanceTotalsWrapper } from "../../components";

export default function UserBalanceTotalsPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <ModalProvider>
      <UserBalanceTotalsWrapper organization={organization} />
    </ModalProvider>
  );
}
